import React, { useState } from "react"

const SourceCard = ({ source }) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <div
      style={{
        border: "1px solid #E5E5E5",
        borderRadius: "8px",
        padding: "8px 12px",
        marginBottom: "4px",
        backgroundColor: "#FAFAFA",
        cursor: "pointer",
        transition: "background-color 0.15s",
      }}
      onClick={() => setExpanded(!expanded)}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F0F0")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#FAFAFA")}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#407775" strokeWidth="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
        </svg>
        <span style={{ fontSize: "12px", fontWeight: "500", color: "#494949", flex: 1 }}>
          {source.type === "table" ? "Azure Table Data" : source.path || "Source"}
        </span>
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#707070"
          strokeWidth="2"
          style={{
            transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s",
          }}
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </div>
      {expanded && source.preview && (
        <p
          style={{
            fontSize: "11px",
            color: "#707070",
            margin: "6px 0 0 22px",
            lineHeight: "1.4",
            whiteSpace: "pre-wrap",
          }}
        >
          {source.preview}
        </p>
      )}
    </div>
  )
}

export default SourceCard
